import { getCommonWidget } from "../../dashWidgetHelper";
import {
    PRODUTURO_SCALE_5_COLORS, PRODUTURO_PIE_COLORS, PRODUTURO_PIE_SINO_COLORS, commonWidgets, getProfuturoAtencion,
    getProfuturoNpsPorMes, getProfuturoTreemap, getProfuturoNpsAcumuladoSemestral
} from "../commonWidgetsProfuturo";


export default {
    title: 'Acompañamiento Dashboard',
    description: 'Acompañamiento Dashboard',
    backgroundClassName: (filters: FiltersUI) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI) => [
        {
            title: 'Principales Indicadores',
            size: [4, 1],
            type: 'label',
            config: { color: '#B7AADC' },
        },

        getProfuturoNpsAcumuladoSemestral({
            size: [1, 2],
            indicator: 'cuest_sofom_ley_pregunta_2',
            extras: {
                periods: 6,
            }
        }),

        getProfuturoNpsPorMes({
            helpText: 'A partir de tu experiencia, en una escala del 0 al 10, dónde 0 es nada probable y 10 muy probable, ¿qué tan probable es que nos recomiendes con un amigo o familiar?',
            size: [1, 2],
            indicator: 'cuest_sofom_ley_pregunta_2',
            historicLabel: 'group',
            historicGrouped: 'responseValue',
            historicGroupByResponseValueId: 173003101,

        }),

        getProfuturoTreemap({
            id: 'cuest_sofom_ley_pregunta_3-treemap',
            title: 'Clientes Detractores',
            helpText: '¿Por qué nos diste esa calificación?',
            size: [2, 2],
            indicators: [
                { name: 'cuest_sofom_ley_pregunta_3', formula: 'count-text', type: 'values' },
                { name: 'COUNT_DISTINCT_RESPONSES', type: 'count' },
            ],

        }),
        getProfuturoTreemap({
            id: 'cuest_sofom_ley_pregunta_5-treemap',
            title: 'Clientes Neutros',
            size: [2, 2],
            helpText: '¿Cómo podríamos mejorar para que nos califiques con 9 o 10?',
            indicators: [
                { name: 'cuest_sofom_ley_pregunta_5', formula: 'count-text', type: 'values' },
                { name: 'cuest_sofom_ley_pregunta_5_count', type: 'count' },
            ],

        }),
        getProfuturoTreemap({
            id: 'cuest_sofom_ley_pregunta_7-treemap',
            title: 'Clientes Promotores',
            helpText: '¿Qué fue lo que más valoraste?',
            size: [2, 2],
            indicators: [
                { name: 'cuest_sofom_ley_pregunta_7', formula: 'count-text', type: 'values' },
                { name: 'cuest_sofom_ley_pregunta_7_count', type: 'count' },
            ],

        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Medio de preferencia',
            size: [2, 2],
            helpText: '¿Por qué medio te gustaría recibir información sobre tu préstamo?',
            indicator: 'cuest_sofom_ley_pregunta_25',
            extraConfigs: {
                colors: PRODUTURO_PIE_COLORS,
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Recomendación',
            size: [2, 2],
            helpText: 'En el último año, ¿recomendaste contratar un préstamo en Profuturo a otras personas?',
            indicator: 'cuest_sofom_ley_pregunta_19',
            extraConfigs: {
                colors: PRODUTURO_PIE_SINO_COLORS,
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Cantidad de personas recomendadas',
            size: [2, 2],
            helpText: '¿A cuántas personas le recomendaste contratar un préstamo en Profuturo?',
            indicator: 'cuest_sofom_ley_pregunta_20',
            extraConfigs: {
                colors: PRODUTURO_PIE_COLORS,
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Recontratación de préstamo',
            size: [2, 2],
            helpText: 'Si tu experiencia con Profuturo se mantiene igual que hasta ahora, ¿estarías dispuesto a volver a contratar un préstamo con nosotros?',
            indicator: 'cuest_sofom_ley_pregunta_21',
            extraConfigs: {
                colors: PRODUTURO_PIE_SINO_COLORS,
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'wordCount',
            title: 'Motivo por el cual vovería a solicitar un préstamo',
            size: [2, 2],
            helpText: '¡Nos alegra escucharlo! ¿Nos podrías contar por qué?',
            indicator: 'cuest_sofom_ley_pregunta_23',
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Motivo por el que no aceptaría un préstamo',
            size: [2, 2],
            helpText: '¿Por qué razón NO estarías dispuesto a volver a contratar un préstamo con nosotros nuevamente?',
            indicator: 'cuest_sofom_ley_pregunta_22',
            extraConfigs: {
                colors: PRODUTURO_PIE_COLORS,
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Principales motivos de contratación',
            size: [2, 2],
            helpText: '¿Cuál es el motivo principal por el que accediste a sacar un préstamo en Profuturo?',
            indicator: 'cuest_sofom_ley_pregunta_9',
            extraConfigs: {
                itemGap: 7,
                center: ['27%', '55%'],
                colors: PRODUTURO_PIE_COLORS,
            },
        }),

        {
            title: 'Atributos en la experiencia de Grado de SATISFACION',
            size: [4, 1],
            type: 'label',
            config: { color: '#B7AADC' },
        },
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La facilidad para comunicarse con Profuturo',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'cuest_sofom_ley_pregunta_12',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La rapidez y facilidad en los procesos / trámites',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'cuest_sofom_ley_pregunta_13',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La buena atención por parte del personal',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'cuest_sofom_ley_pregunta_14',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'El cumplimiento con lo que me ofrecieron al momento de la contratación',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'cuest_sofom_ley_pregunta_15',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La recepción de mi Estado de Cuenta de manera puntual (mensualmente)',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'cuest_sofom_ley_pregunta_16',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La comunicación recibida por parte de Profuturo',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'cuest_sofom_ley_pregunta_17',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La frecuencia con la que me contactan / mandan información',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'cuest_sofom_ley_pregunta_18',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'textAnalysis',
            title: 'Análisis de Sentimientos',
            size: [4, 4],
            indicator: 'SENTIMENT',
        }),
    ]
} as DasboardConfig